import Cookies from 'js-cookie';
import { PromoDetails } from './types';

const setPromoDetailsCookie = (promoDetails: PromoDetails) => {
  Cookies.set('promoDetails', JSON.stringify(promoDetails));
  return;
};

export default setPromoDetailsCookie;
